/**
 * Created by olga on 26.10.2022
 */

const PointToCustomersHintContent = function (options) {
    this.pointToCustomersInBound = options.pointToCustomersInBound;
    this.unit = options.unit;

    this.doNotBlock = {
        x: this.unit.x,
        y: this.unit.y
    };
};

PointToCustomersHintContent.isApplicable = function (options) {
    return options.pointToCustomersInBound !== undefined;
};

PointToCustomersHintContent.prototype.hasSameContent = function (options) {
    return this.pointToCustomersInBound === options.pointToCustomersInBound && Unit.Equals(this.unit, options.unit);
};

PointToCustomersHintContent.prototype.getMessages = function () {
    const messages = [{ text: Messages.get("PointToCustomersHintContent1") }];
    Map2d.currentMap.customers.listCustomersWithRecipe().forEach((c) => {
        messages.push({ icon: UnitView.getUnitImage(c.unit, { preferStatic: true }) });
    });

    messages.push({ text: Messages.get("PointToCustomersHintContent2") });
    return messages;
};